module.exports = __webpack_public_path__ + "media/custom/images/pocstock_contribute-step-01-87401c1bee0484e56489ecd6ef7807ef.png";